<template>
    <div class="charts-wrapper" v-if="listError.length > 0 || $store.state.report.downloadProcess.length > 0">
        <div class="set-size charts-container" @click="modalOpen = 'summary'" v-if="modalOpen == 'progress'">
            <div class="pie-wrapper" :class="'progress-' + progressTotal">
                <span class="label">
                    <i class="bx bx-download"></i>
                </span>
                <div class="pie">
                    <div class="left-side half-circle"></div>
                    <div class="right-side half-circle"></div>
                </div>
            </div>
        </div>

        <div class="download-float-open" v-if="modalOpen == 'summary'">
            <div class="download-float-open__header" @click="modalOpen = 'progress'">
                Proses Mengunduh...
            </div>
            <div class="download-float-open__body">
                {{$store.state.report.downloadProcess.length}} Laporan dalam proses
                <span class="download-float-open__count">0/{{$store.state.report.downloadProcess.length}}</span>
                <b-progress :value="progressTotal" max="100" show-progress class="mb-3" height="15px"></b-progress>
            </div>
            <div class="download-float-open__footer">
                <b-button variant="outline-primary" class="mc-btn-input d-inline-block w-100 mt-0" @click="modalOpen = 'detail'">
                    Detail
                </b-button>
            </div>
        </div>

        <div class="download-float-history" v-if="modalOpen == 'detail'">
            <div class="download-float-history__header">
                Detail
            </div>
            <div class="download-float-history__body">
                <b-tabs content-class="mt-3" class="mt-3">
                    <b-tab :title="'Dalam Proses' + ' (' + $store.state.report.downloadProcess.length + ')'" active>
                        <div class="download-list" v-for="download in $store.state.report.downloadProcess" :key="download.downloadedAt">
                            <div class="download-list__title">
                                <span>{{download.name}}</span>
                                <div class="download-list__title--timestamp">
                                    <a href="#">
                                        <i class="fa fa-download"></i>
                                    </a>
                                    {{ download.downloadedAt }}
                                </div>
                            </div>
                            <b-progress :value="download.percentage" max="100" show-progress class="mt-2" height="15px"></b-progress>
                            <div class="download-list__periode">
                                Periode : {{ download.periode }}
                            </div>
                        </div>
                        <div v-if="$store.state.report.downloadProcess.length == 0" class="text-center">
                            Tidak ada proses unduh berlangsung.
                        </div>
                    </b-tab>
                    <b-tab :title="'Gagal' + ' (' + listError.length + ')'">
                        <div class="download-list error" v-for="(error, index) in listError" :key="index">
                            <div class="download-list__error">
                                <div class="download-list__error--list">
                                    <div class="download-list__title">
                                        <span>{{error.title}} Tanggal {{ momentDateShortMonth(error.startDate) }} - {{ momentDateShortMonth(error.endDate) }}.{{ error.typeCode.charAt(1) == 'P' ? 'pdf' : 'xlsx' }}</span>
                                        <div class="download-list__title--timestamp">
                                            <a href="#">
                                                <i class="fa fa-download"></i>
                                            </a>
                                            {{ momentDMHms(error.downloadOn) }}
                                        </div>
                                    </div>
                                    <b-progress value="90" max="100" show-progress class="mt-2" height="15px"></b-progress>
                                    <div class="download-list__periode">
                                        Periode : {{ momentDateShortMonth(error.startDate) }} - {{ momentDateShortMonth(error.endDate) }}
                                    </div>
                                </div>
                                <div class="download-list__error--reload">
                                    <button class="btn-cancel-download" @click="cancelDownload(error)"><i class="fas fa-times"></i> Batal Unduh</button>
                                    <button class="btn-cancel-refresh" @click="reDownload(error)"><i class="fas fa-redo"></i> Ulangi Unduh</button>
                                </div>
                            </div>
                        </div>
                        <div v-if="listError.length == 0" class="text-center">
                            Tidak ada proses unduh yang gagal.
                        </div>
                    </b-tab>
                </b-tabs>
            </div>
            <div class="download-float-open__footer mt-3">
                <b-button variant="outline-primary" class="mc-btn-input d-inline-block w-100 mt-0" @click="modalOpen = 'summary'">
                    Ringkasan
                </b-button>
            </div>
        </div>

        <!-- Modal for Delete Confirmation -->
        <b-modal
            class="mc-modal"
            id="modal-delete"
            title="Hapus"
            size="md"
            centered
            scrollable
        >
            <div class="card-body mc-modal__filter p-2">
                <p>Apakah Anda yakin membatalkan unduhan ini?</p>
            </div>
            <template #modal-footer="{ cancel }">
                <b-row class="mc-modal__filter-footer mx-0">
                    <b-col sm="12" md="12" class="mc-modal__filter-footer-btn">
                        <b-button
                            variant="outline-primary"
                            @click="cancel()"
                            class="me-2"
                        >
                            Tidak
                        </b-button>
                        <b-button @click="toDelete" variant="primary"> Ya </b-button>
                    </b-col>
                </b-row>
            </template>
        </b-modal>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Helper } from "@/mixin/helper";
import {
    DELETE_DOWNLOAD_HISTORY,
    RELOAD_DOWNLOAD_HISTORY
} from "@/services/api/report/report";
import moment from "moment";
moment.locale("id");

export default {
    props: {
        errorData: {
            type: Array
        },
    },
    mixins: [Helper],
    data() {
        return {
            loading: 0,
            modalOpen: 'progress',
            selected: {},
            listError: this.errorData
        }
    },
    computed: {
        ...mapGetters("report", ["showProgress"]),
        progressTotal() {
            if(this.showProgress > 0 && this.showProgress <= 25) {
                return 25;
            }else if(this.showProgress > 25 && this.showProgress <= 50) {
                return 50;
            }else if(this.showProgress > 50 && this.showProgress <= 75) {
                return 75;
            }else if(this.showProgress > 75 && this.showProgress <= 90) {
                return 90;
            }

            return 0;
        }
    },
    watch: {
        errorData: function(newVal) {
            this.listError = newVal;
            if(newVal.length == 0) {
                this.modalOpen = 'progress'
            }
        }
    },
    mounted() {
        this.$parent.$parent.$parent.refreshDownloadHistory();
    },
    methods: {
        cancelDownload(data) {
            this.selected = data;
            this.$bvModal.show("modal-delete");
        },
        toDelete() {
            var self = this;

            this.$apollo.mutate({
                mutation: DELETE_DOWNLOAD_HISTORY,
                variables: {
                    filter: {
                        userId: this.selected.userId,
                        title: this.selected.title,
                        filter: this.selected.filter,
                        startDate: this.selected.startDate,
                        endDate: this.selected.endDate,
                        downloadOn: this.selected.downloadOn,
                        typeCode: this.selected.typeCode,
                        status: this.selected.status
                    }
                },
            }).then(() => {
                self.$toast.success(`Unduhan berhasil dihapus`);
                self.$bvModal.hide("modal-delete");
                self.$parent.$parent.$parent.refreshDownloadHistory();
            })
        },
        reDownload(data) {
            var index = this.listError.indexOf(data);
            if (index !== -1) {
                this.listError.splice(index, 1);
            }
            
            var downloadProgress = {
                name : data.title + moment(data.startDate).format("DD MMM YYYY") + ' - ' + moment(data.endDate).format("DD MMM YYYY")+'.' + data.typeCode.charAt(1) == 'P' ? 'pdf' : 'xlsx',
                periode : moment(data.startDate).format("DD MMM YYYY") + ' - ' + moment(data.endDate).format("DD MMM YYYY"),
                downloadedAt : moment().format('DD MMM YYYY HH:mm:ss'),
                percentage : 0,
                type : data.typeCode.charAt(1) == 'P' ? 'pdf' : 'excel'
            };
            this.$store.commit("report/saveProgress", downloadProgress);
            
            var percentage = 0;
            var intervalDownload = setInterval(() => {
                if(percentage< 75) {
                percentage += 25;
                }else if(percentage== 75) {
                percentage = 90;
                }else if(percentage == 90) {
                clearInterval(intervalDownload);
                }
                this.$store.commit("report/updateProgress", {progress: downloadProgress, percentage: percentage});
            }, 500);

            var self = this;
            this.$apollo
                .query({
                    query: RELOAD_DOWNLOAD_HISTORY,
                    variables: {
                        filter: {
                            userId: data.userId,
                            title: data.title,
                            filter: data.filter,
                            startDate: data.startDate,
                            endDate: data.endDate,
                            downloadOn: data.downloadOn,
                            typeCode: data.typeCode,
                            status: data.status
                        }
                    },
                    fetchPolicy: 'no-cache'
                    }).then(res => {
                        var isSuccessful = res.data.redownloadDownloadHistory.isSuccessful;
                        if(isSuccessful) {
                            clearInterval(intervalDownload);
                            self.$store.commit("report/updateProgress", {progress: downloadProgress, percentage: 100});
                            self.$store.commit("report/deleteProgress", downloadProgress);
                            self.$parent.$parent.$parent.refreshDownloadHistory();
                        }else {
                            clearInterval(intervalDownload);
                            self.$store.commit("report/updateProgress", {progress: downloadProgress, percentage: 90});
                            self.$store.commit("report/deleteProgress", downloadProgress);
                            self.$parent.$parent.$parent.refreshDownloadHistory();
                        }
                    })
        }
    }
}
</script>